// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3wtxu","content":"GlobalSearch_content__3IeQp"};